import React from 'react';
import delhigovt from '../static/delhigovt.svg';
import Footer from './Footer';
import gplay from '../static/gplay.svg';
import appstore from '../static/appstore.svg';





// eslint-disable-next-line react/prefer-stateless-function
class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div>
        <main>
          <div className="maintitlebar">
            <h1>Privacy Policy</h1>
            <img
              src={delhigovt}
              style={{ height: '70px' }}
            />
          </div>
          <div className="main-sections">
            <div id="privacy">
              <p>
                Delhi Corona aims to fight COVID-19 through the dual lens of infodemic and pandemic management.
                <br/>
                By agreeing to using our Service, you will be agreeing to the collection and use of information in relation to this policy. The Personal Information collected will be used for providing and improving the Service. Your information will not be shared with anyone except as described in this Privacy Policy.
              </p>
              <strong>
                Information Collection and Use
              </strong>
              <p>
                For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to Location. The information requested will be retained on your device and shall not be collected by us in any form or way.
                The app uses third party services that may collect information that can lead to user identification.
                Link to privacy policy of third party service providers used by the app
              </p>
              <p>
              <ul style={{
                display: 'block',
                textDecoration: 'underline'
              }}>
                <li>
                  <a href="https://www.google.com/policies/privacy/" target="_blank">Google Play Services</a>
                </li>
                <li>
                  <a href="https://firebase.google.com/policies/analytics" target="_blank">Google Analytics for Firebase</a>
                </li>
                <li>
                  <a href="https://firebase.google.com/support/privacy/" target="_blank">Firebase Crashlytics</a>
                </li>
              </ul>
              <br/>
				  <strong>
            Log Data
				  </strong>
				  <p>
            During the use of our Service, in the case of an error in the app, we will collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
				  </p>
				  <strong>
              Cookies
				  </strong>
				  <p>
            We do not use “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.      </p>
            <strong>
              Service Providers
            </strong>
          </p>
				  <p>
            Third-party companies and individuals may be employed due to the following reasons:
				  <ul>
					 <li>To facilitate our Service;</li>
					 <li>To provide the Service on our behalf;</li>
					 <li>To perform Service-related services; or</li>
					 <li>To assist us in analyzing how our Service is used.</li>
				  </ul>
			The users of our Service are hereby informed that these third parties have access to your Personal Information. This is to facilitate the performance of the tasks assigned to them on our behalf. However, they are obligated not to disclose or use this information for any other purpose.
				  </p>
				  <strong>Security</strong>
				  <p>
			We value your trust in providing us with your Personal Information, and Delhi Corona strives to use commercially acceptable means of protecting it. It is worth noting, however, that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and its absolute security cannot be guaranteed.
				  </p>
				  <strong>
			Links to Other Sites
				  </strong>
				  <p>
			The Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. We strongly advise you to review the Privacy Policy of these websites.Delhi Corona has no control over and assumes no responsibility for the content, privacy policies, or practices of any third-party sites or services.
				  </p>
				  <strong>
			Children’s Privacy
				  </strong>
				  <p>
			These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, it shall be immediately deleted from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to take necessary actions.
				  </p>
				  <strong>
			Application Updation
				  </strong>
				  <p>
			At some point, we may wish to update the app. The app is currently available on Android – the requirements for this system (and for any additional systems we decide to extend the availability of the app to) may change, and you may need to download the updates if you would want to keep using the app. We do not promise that we will always update the app so that it is relevant to you and/or works with the Android version that you have installed on your device. We may also wish to stop providing the Service, and may terminate use of the app at any time without giving prior notice of termination to you. Unless we tell you otherwise, upon any termination, (a) the rights and licenses granted to you in these terms will end; (b) you must stop using the app, and (if needed) delete it from your device.
				  </p>
				  <strong>
			User’s Responsibility
				  </strong>
				  <p>
			This app stores and processes personal data that you have provided to us as described above. It’s your responsibility to keep your phone and access to the app secure. We therefore recommend that you do not jailbreak or root your phone, which is the process of removing software restrictions and limitations imposed by the official operating system of your device. It could make your phone vulnerable to malware/viruses/malicious programs, compromise your phone’s security features and it could mean that the app won’t work properly or at all.
				  </p>
				  <strong>
			Changes to This Privacy Policy
				  </strong>
				  <p>
			We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. You will be notified of any changes by posting of the new Privacy Policy on this page. <br/>
			This policy is effective as of 2020-04-23.

				  </p>
				  <strong>Contact Us</strong>
				  <p>
            If you have any questions or suggestions regarding the Privacy Policy, feel free to reach out to us at - delhicovidtech@gmail.com
				  </p>
            </div>
          </div>
          <div>
                <h6 style={{borderBottom: 'none', paddingBottom: '5px'}}>Download The Official App</h6>
                <div>
                  <a href="https://play.google.com/store/apps/details?id=com.delhi.covidcare">  <img src={gplay} style={{marginRight: '6px'}}/> </a>
                  <a href="https://apps.apple.com/in/app/delhi-corona/id1516485091"> <img src={appstore}/>  </a>  
                </div>
            </div>
        </main>
        <Footer />
      </div>
    );
  }
}

export default PrivacyPolicy;
